import { render } from "./Order_edit.vue?vue&type=template&id=c2ededa4"
import script from "./Order_edit.vue?vue&type=script&lang=js"
export * from "./Order_edit.vue?vue&type=script&lang=js"

import "./Order_edit.vue?vue&type=style&index=0&id=c2ededa4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__